<template>
    <v-card>
        <v-card-title>
            {{  $t('dedicated_server')  }} {{ webinar.title}}
        </v-card-title>
        <v-card-text>
            <v-form ref="serverForm">
                <v-row>
                    <v-col cols="12">
                        <v-combobox v-model="selectedServer" :items="servers" 
                        item-text="domain" item-value="domain" label="URL" class="left-input mt-3" @change="setSecret"></v-combobox>
                    </v-col> 
                    <v-col cols="12">
                        <v-text-field v-model="serverEditedItem.bigbluebutton_url" label="URL" class="left-input mt-3" ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="serverEditedItem.bigbluebutton_secret" label="Secret" class="left-input mt-3">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-checkbox v-model="serverEditedItem.bigbluebutton_record" label="Recording" :value="true"></v-checkbox>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn text color="green darken-2" @click="saveServer">
                {{  $t('save')  }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text color="red darken-2" @click="removeAskDialog=true" v-show="false">
                {{  $t('remove')  }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="close">
                {{  $t('close')  }}
            </v-btn>
        </v-card-actions>
        <v-dialog v-model="removeAskDialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <v-icon large right color="red"> mdi-comment-question-outline</v-icon>
                </v-card-title>
                <v-card-text>
                    {{ $t('webinar_dedicated_server_remove_ask')}}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="removeServer">{{ $t('yes') }}</v-btn>
                    <v-btn color="primary" text @click="removeAskDialog=false">{{ $t('no') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import axios from 'axios'
export default {
    name: 'DedicatedServer',
    props: ['webinar'],
    data() {
        return {
            serverEditedItem: { bigbluebutton_url: "", bigbluebutton_secret: "", bigbluebutton_record: false },
            serverDefaultItem: { bigbluebutton_url: "", bigbluebutton_secret: "", bigbluebutton_record: true },
            saveLoading: false,
            deleteLoading: false,
            removeAskDialog:false,
            servers:[],
            selectedServer:{domain:'',secret:''},
        }
    },
    watch:{
        webinar:{
            handler(){
                this.getServerInfo();
            },
            deep:true
        }
    },
    methods: {

        getServerInfo() {
            axios({
                url: process.env.VUE_APP_BACKEND_URL+"/api/webinar_plus/bbb_server/"+this.webinar.id,
                method: "GET",
                headers: {
                    // 'Content-Type': 'multipart/form-data',
                    Authorization: this.$store.get("login/token"),
                },
            }).then(response => {
                console.log(response.data.bigbluebutton_secret)
                this.serverEditedItem = Object.assign({}, response.data);
               // this.serverEditedItem.bigbluebutton_record=(response?.data?.data?.bigbluebutton_record==1?true:false)
            }).catch(error => {
                console.log(error.response);
                this.$toasted.error(this.$t("no_dedicated_server"));
            });
        },
        saveServer() {
            console.log(this.serverEditedItem)
            let payload={company_id:this.webinar.id,...this.serverEditedItem};
            axios({
                url: process.env.VUE_APP_BACKEND_URL+"/api/webinar_plus/bbb_server/"+this.webinar.id,
                method: "PUT",
                headers: {
                    // 'Content-Type': 'multipart/form-data',
                    Authorization: this.$store.get("login/token"),
                },
                data: payload,
            }).then(() => {
                this.$toasted.success(this.$t("dedicated_server_save_successfully"));
                this.close()

            }).catch(error => {
                console.log(error.response);
                this.$toasted.error(this.$t("dedicated_server_saving_error"));
            });
        }, 
        removeServer() {
            let payload={company_id:this.webinar.id,...this.serverEditedItem};
            axios({
                url: process.env.VUE_APP_SUPPORT_URL+"api/delete_bbb",
                method: "POST",
                headers: {
                    // 'Content-Type': 'multipart/form-data',
                    Authorization: this.$store.state.token,
                },
                data: payload,
            }).then(() => {
                this.serverEditedItem = Object.assign({}, this.serverDefaultItem);
                this.$toasted.success(this.$t("dedicated_server_delete_successfully"));
                this.removeAskDialog=false;
                this.close();

            }).catch(error => {
                console.log(error.response);
                this.$toasted.error(this.$t("dedicated_server_deleteing_error"));
            });
        },
    getServers() {
      axios({
        url: process.env.VUE_APP_BACKEND_URL + "/api/virtual_machine/getWithSecrets",
        method: "GET",
        headers: {
          Authorization: this.$store.get("login/token"),
        },
      
      })
        .then((response) => {
            console.log(response);
          this.servers = response.data
          
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setSecret(){
        this.serverEditedItem.bigbluebutton_url = `https://${this.selectedServer.domain}/bigbluebutton/`;
        this.serverEditedItem.bigbluebutton_secret = this.selectedServer.secret;
    },
        close() {
            // this.serverEditedItem = Object.assign({}, this.serverDefaultItem);
            //this.selectedServer={bigbluebutton_secret:'',bigbluebutton_url:''}
            this.$emit('close');
        }
    },
    mounted() {
        this.getServers();
        this.getServerInfo();
    },



}
</script>
<style >
.left-input input{
    text-align: left;
    direction: ltr;
}
</style>